import { FUNCTIONAL_DOMAIN_KEY } from "../utils/types/patientIntakePreviewTypes";

export const HEALTH_HISTORY_IDS = {
  HISTORY_OF_PRESENT_ILLNESS: "history_of_present_illness",
  PSYCHIATRIC_HISTORY: "psychiatric_history",
  MEDICAL_HISTORY: "medical_history",
  SYMPTOM_PROGRESSION_OVER_TIME: "symptom_progression_over_time",
} as const;

export const HEALTH_HISTORY_IDS_V3 = {
  HISTORY_OF_PRESENT_ILLNESS: "history_of_present_illness",
  PSYCHIATRIC_HISTORY: "psychiatric_history",
  MEDICAL_HISTORY: "medical_history",
  SYMPTOM_PROGRESSION_OVER_TIME: "symptom_progression_over_time",
  SUBSTANCE_HISTORY: "substance_history",
} as const;

export const PERSONAL_LIFE_HISTORY_IDS = {
  SUBSTANCE_HISTORY: "substance_history",
  PAST_PERSONAL_HISTORY: "past_personal_history",
  EDUCATIONAL_HISTORY: "educational_history",
  FAMILY_HISTORY: "family_history",
} as const;

export const PERSONAL_LIFE_HISTORY_IDS_V3 = {
  PAST_PERSONAL_HISTORY: "past_personal_history",
  EDUCATIONAL_HISTORY: "educational_history",
  FAMILY_HISTORY: "family_history",
} as const;

export const AI_CONVERSATION_HISTORY_CODES = {
  AI_SUMMARY_OF_CONVERSATION_HISTORY: "ai_summary_conversation_history",
  CONFLICTING_SIGNALS: "conflicting_signals",
  CONGRUENT_SIGNALS: "congruent_signals",
  NOVEL_SIGNALS: "novel_signals",
  PATIENT_REFLECTION: "patient_reflection",
} as const;

export const PREVIEW_TITLE_CODES = {
  HEALTH_HISTORY: "health_history",
  PERSONAL_LIFE_HISTORY: "personal_life_history",
  FUNCTIONAL_DOMAINS: "functional_domains",
  TREATMENT_RECOMMENDATIONS: "treatment_recommendations",
  AI_CONVERSATION_HISTORY: "ai_conversation_history",
} as const;

export const TREATMENT_RECOMMENDATIONS_CODES = {
  COGNITIVE_BEHAVIORAL_THERAPY: "cognitive_behavioral_therapy",
  INSIGHT_ORIENTED_THERAPY: "insight_oriented_therapy",
  PRESCRIBER_CONSIDERATIONS: "prescriber_considerations",
} as const;

export const ALL_HEALTH_HISTORY_IDS = Object.values(HEALTH_HISTORY_IDS);
export const ALL_HEALTH_HISTORY_IDS_V3 = Object.values(HEALTH_HISTORY_IDS_V3);

export const ALL_PERSONAL_LIFE_HISTORY_IDS = Object.values(
  PERSONAL_LIFE_HISTORY_IDS,
);
export const ALL_PERSONAL_LIFE_HISTORY_IDS_V3 = Object.values(
  PERSONAL_LIFE_HISTORY_IDS_V3,
);

export const ALL_TREATMENT_RECOMMENDATIONS_CODES = Object.values(
  TREATMENT_RECOMMENDATIONS_CODES,
);

export const ALL_AI_CONVERSATION_HISTORY_CODES = Object.values(
  AI_CONVERSATION_HISTORY_CODES,
);

export const previewSectionCodeToLabel = {
  [FUNCTIONAL_DOMAIN_KEY.enjoyment]: "Enjoyment",
  [FUNCTIONAL_DOMAIN_KEY.family]: "Family",
  [FUNCTIONAL_DOMAIN_KEY.health]: "Health",
  [FUNCTIONAL_DOMAIN_KEY.hope]: "Hope",
  [FUNCTIONAL_DOMAIN_KEY.money]: "Money",
  [FUNCTIONAL_DOMAIN_KEY.post_partum]: "New motherhood",
  [FUNCTIONAL_DOMAIN_KEY.mood]: "Mood",
  [FUNCTIONAL_DOMAIN_KEY.relationships]: "Relationships",
  [FUNCTIONAL_DOMAIN_KEY.social_support]: "Social support",
  [FUNCTIONAL_DOMAIN_KEY.work]: "Work",
  [HEALTH_HISTORY_IDS.HISTORY_OF_PRESENT_ILLNESS]: "History of present illness",
  [HEALTH_HISTORY_IDS.PSYCHIATRIC_HISTORY]: "Psychiatric history",
  [HEALTH_HISTORY_IDS.MEDICAL_HISTORY]: "Medical history",
  [HEALTH_HISTORY_IDS.SYMPTOM_PROGRESSION_OVER_TIME]:
    "Symptom progression over time",
  [PERSONAL_LIFE_HISTORY_IDS.SUBSTANCE_HISTORY]: "Substance history",
  [PERSONAL_LIFE_HISTORY_IDS.PAST_PERSONAL_HISTORY]: "Past personal history",
  [PERSONAL_LIFE_HISTORY_IDS.EDUCATIONAL_HISTORY]: "Educational history",
  [PERSONAL_LIFE_HISTORY_IDS.FAMILY_HISTORY]: "Family history",
  [TREATMENT_RECOMMENDATIONS_CODES.COGNITIVE_BEHAVIORAL_THERAPY]:
    "Cognitive behavioral therapy (CBT)",
  [TREATMENT_RECOMMENDATIONS_CODES.INSIGHT_ORIENTED_THERAPY]:
    "Insight-oriented therapy",
  [TREATMENT_RECOMMENDATIONS_CODES.PRESCRIBER_CONSIDERATIONS]:
    "Prescriber considerations",
  [AI_CONVERSATION_HISTORY_CODES.AI_SUMMARY_OF_CONVERSATION_HISTORY]:
    "Patient AI conversation summary",
  [AI_CONVERSATION_HISTORY_CODES.CONFLICTING_SIGNALS]: "Conflicting signals",
  [AI_CONVERSATION_HISTORY_CODES.CONGRUENT_SIGNALS]: "Congruent signals",
  [AI_CONVERSATION_HISTORY_CODES.NOVEL_SIGNALS]: "Novel signals",
  [AI_CONVERSATION_HISTORY_CODES.PATIENT_REFLECTION]: "Patient reflection",
} as const;
